module.exports = __webpack_public_path__ + "img/logo-old.48bec56b.png";